module.exports = __webpack_public_path__ + "static/media/danone.9f4a0ed4.png";